import React, {Component} from 'react';
import { connect } from 'react-redux';
import { requestUpload }  from '../../../SHARED/actions/image.actions';

class Uploader extends Component {
    state = {
        showUploadButton: false,
        selectedFile: null
    }

    fileSelectedHandler = event => {
        this.setState({
            showUploadButton: true,
            selectedFile: event.target.files[0]
        });
    }

    fileUploadHandler = () => {
        const fd = new FormData();
        fd.append('image', this.state.selectedFile, this.state.selectedFile.name);

        this.props.requestUpload();
    }

    initiateUpload = () => {
        this.fileInput.click()
    }

    render() {
        return (
            <div>
                <input
                    style={{display: 'none'}}
                    type="file"
                    onChange={this.fileSelectedHandler}
                    ref={fileInput => this.fileInput = fileInput}
                />

                <br/>
                <span onClick={this.initiateUpload}>Incarca fisier</span>

                <br/>
                <button
                    style={!this.state.showUploadButton ? {display: 'none'} : {}}
                    onClick={this.fileUploadHandler}>
                    Upload image
                </button>
            </div>
        )
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {requestUpload})(Uploader);



// WEBPACK FOOTER //
// ./src/SHARED/components/uploader/uploader.component.js